import { render, staticRenderFns } from "./forgotpwd.vue?vue&type=template&id=38e4e630&scoped=true&"
import script from "./forgotpwd.vue?vue&type=script&lang=js&"
export * from "./forgotpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4e630",
  null
  
)

export default component.exports